import GlobalModal from "../../GlobalModal/Modal/GlobalModal";
import QucikReplyCard from "../../QuickReplyCard";
const LinkFile = {
    'modal' : GlobalModal,
    'QucikReplyCard': QucikReplyCard
}
export default LinkFile;